export enum GtmEventsConfig {
  PublishBot = 'bot_published',
  SubscribeToNotifications = 'subscribe_to_notifications',
}
